export const trimName = (text: string, maxLength: number, nameEnding = ".") => {
  let _text = text

  if (_text.length >= maxLength) {
    _text = `${_text.substring(0, maxLength - 1)}${nameEnding}`
  }

  return _text
}
